// Checkbox toolkitu przepisuje href i kwote na przycisku. Nic wiecej -
// bez koszyka, bez fetcha, bez stanu. Jedno klikniecie od decyzji do kasy.
//
// Snippet aiofm-buy.liquid moze wyrenderowac sie kilka razy na stronie
// (landing ma przycisk przy toolkicie i przy tierach), wiec ten plik moze
// wykonac sie wielokrotnie. Straznik siedzi na ELEMENCIE, nie globalnie:
// inaczej drugi render zostalby bez obslugi.
(() => {
  const bind = (box) => {
    if (box.dataset.aiofmBound) return;
    box.dataset.aiofmBound = '1';

    const cta = box.querySelector('[data-aiofm-cta]');
    const amount = box.querySelector('[data-aiofm-amount]');
    const bump = box.querySelector('[data-aiofm-bump]');
    const { vid, tid, base, total } = box.dataset;
    if (!cta || !amount || !bump || !tid) return;

    const root = new URL(cta.getAttribute('href'), location.href).pathname
      .replace(/cart\/.*$/, '');

    const apply = () => {
      const on = bump.checked;
      cta.setAttribute('href', on ? `${root}cart/${vid}:1,${tid}:1` : `${root}cart/${vid}:1`);
      amount.textContent = on ? total : base;
    };

    bump.addEventListener('change', apply);
    // Przegladarka potrafi przywrocic zaznaczenie przy powrocie wstecz,
    // a wtedy href musialby juz byc zgodny z tym, co widac.
    apply();
  };

  const bindAll = () => document.querySelectorAll('[data-aiofm-buy]').forEach(bind);

  bindAll();
  // Edytor motywu przeladowuje sekcje bez przeladowania strony.
  document.addEventListener('shopify:section:load', bindAll);
  window.addEventListener('pageshow', bindAll);
})();
